module.exports = __webpack_public_path__ + "img/Frente-16-02 open.3a7a5066.jpg";